<template>
  <component :is="tag" :class="$options.name" v-html="richText(value)"/>
</template>
<script>
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
export default {
  name: "RichText",
  methods: {
    formatLink(value) {
      return value.toLowerCase().replace(/[^A-Za-z0-9']/g, "");
    },
    richText(value) {
      const options = {
        renderNode: {
          [BLOCKS.EMBEDDED_ASSET]: node =>
            `<figure class="Img"><span class="Img__wrap"><img src="${
              node.data.target.fields.file.url
            }?fm=jpg&fl=progressive&w=1280" alt="${node.data.target.fields.title}"/></span></figure>`,
          [INLINES.ENTRY_HYPERLINK]: (node, next) =>
            `<a href="/${node.data.target.sys.contentType.sys.id === 'news' ? 'news':'builds'}/${this.formatLink(node.data.target.fields.title)}">${next(node.content)}</a>`
        }
      };
      return documentToHtmlString(value, options);
    }
  },
  props: {
    tag: { default: "section" },
    value: { default: "Some great text" }
  }
};
</script>